import React from 'react';
import PropTypes from 'prop-types';
import TaxFlowChartButton from './TaxFlowChartButton';

const TaxFlowChartSectionFour = (props) => {
  const yesButtonActive = props.section > 3 && props.partnerInsurance ? 'active' : '';
  const noButtonActive = props.section > 3 && !props.partnerInsurance ? 'active' : '';
  return (
    <React.Fragment>
      <div className="row tax-flow-chart-question-four">
        <div className="col-sm-4 col-sm-offset-1 tax-flow-chart-pipe">
          <p>Bonus question: Do you have health insurance through your partner? </p>
        </div>
      </div>
      <div className="row tax-flow-chart-answer-four tax-flow-chart-button-row">
        <TaxFlowChartButton
          colClasses="col-sm-2 col-sm-offset-2 tax-flow-chart-button-col-left"
          buttonClasses={`tax-flow-chart-button-yes ${yesButtonActive}`}
          onClick={() => props.setPartnerInsurance(true)}
          text="Yes"
        />
        <TaxFlowChartButton
          colClasses="col-sm-2 col-sm-offset-4 tax-flow-chart-button-col-right"
          buttonClasses={`${noButtonActive}`}
          onClick={() => props.setPartnerInsurance(false)}
          text="No"
        />
      </div>
    </React.Fragment>
  );
};

TaxFlowChartSectionFour.propTypes = {
  section: PropTypes.number.isRequired,
  partnerInsurance: PropTypes.bool.isRequired,
  setPartnerInsurance: PropTypes.func.isRequired,
};

export default TaxFlowChartSectionFour;



// WEBPACK FOOTER //
// ./src-react/TaxFlowChart/components/TaxFlowChartSectionFour.jsx